"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const a=require("@mui/material"),n=require("@mui/material/styles"),c=require("../../assets/icons/AnamnesisAttention.js"),d=require("../../assets/icons/AnamnesisDone.js"),u=require("../../assets/icons/AnamnesisInProgress.js"),s=require("../../patient-today-list.types.js");require("react/jsx-runtime");const r=t=>({[s.DocumentStatus.INVALID]:{border:"#FF647C",text:t.palette.error[500],background:t.palette.error[50]},[s.DocumentStatus.MISSING]:{border:"#FF647C",text:t.palette.error[500],background:t.palette.error[50]},[s.DocumentStatus.IN_PROGRESS]:{border:"#C99B0F",text:t.palette.warning[600],background:t.palette.warning[50]},[s.DocumentStatus.DONE]:{border:"#51AA76",text:t.palette.success[500],background:t.palette.success[50]}}),l=n.styled(a.Chip,{shouldForwardProp:t=>t!=="isOpen"&&t!=="status"})`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 2px;
  background: transparent;

  ${({theme:t,status:e,isOpen:i})=>e&&r(t)[e]&&n.css`
      border-color: ${i?r(t)[e].border:"transparent"};

      & button {
        color: ${r(t)[e].text};
      }

      &:hover {
        border-radius: 50%;
        background-color: ${r(t)[e].background};
      }
    `}

  .MuiChip-label {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    background: transparent;
  }
`,p=n.styled(a.Button)`
  display: flex;
  align-items: center;
  min-width: 0;
  padding: 0;
  background-color: transparent;

  &:hover {
    background-color: transparent;
  }
`,o={width:"18px",height:"18px"},g=n.styled(c)(o),b=n.styled(d)(o),_=n.styled(u)(o);exports.AnamnesisAttentionIcon=g;exports.AnamnesisDoneIcon=b;exports.AnamnesisInProgressIcon=_;exports.StatusButton=p;exports.StatusChip=l;
